import React from 'react'


const List = ({ Elem, data, ...props }) => {

  return (
    <div className={`map__list`}>

      <ul>
        {data.map((item,i) => (
          <li key={i}>
            <Elem {...item} {...props} i={i} />
          </li>
        ))}
      </ul>
    </div>
  )
}
export default List;
